import { generateTweenData, startTweenData } from './tween';
import { gameModuleStore } from '../gameModule/store/gameModuleStore';
import { mousePositionToIconColumnRow } from './mousePositionToIconICoordinates';
import { gameConfigurationStore } from '../gameModule/store/gameConfigurationStore';

class TouchController {
  constructor(iconsContainer, winContainer, reels) {
    this.iconsContainer = iconsContainer;
    this.winContainer = winContainer;
    this.reels = reels;
    this.iconsHeight = gameConfigurationStore.reelsParams[0].iconsHeight;
    this.lastY = 0;
    this.touchY = 0;
    this.touchMoving = false;
    this.moveDistance = 0;
    this.returnControl = null;
    this.pressedColumn = -1;
    this.returningToThePlace = false;
    this.activePointerId = null;
    this.target = iconsContainer;
    this.secondTarget = winContainer;
    this.setInteractive(gameConfigurationStore.isReplay ? false : true);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.returnToThePlace = this.returnToThePlace.bind(this);

    iconsContainer.on('pointerdown', this.onTouchStart);
    winContainer.on('pointerdown', this.onTouchStart);
    iconsContainer.on('pointerup', this.returnToThePlace);
    iconsContainer.on('pointerupoutside', this.returnToThePlace);
    iconsContainer.on('pointermove', this.onPointerMove);
    iconsContainer.on('pointerout', this.returnToThePlace);
  }

  setInteractive(interactive) {
    this.target.interactive = interactive;
    this.secondTarget.interactive = interactive;
    this.target.cursor = interactive ? 'grab' : 'default';
    this.secondTarget.cursor = interactive ? 'grab' : 'default';
  }

  stopReturn() {
    if (this.returnControl) {
      this.returnControl.stop();
      this.returnControl = null;
    }
  }

  reset() {
    this.target.cursor = 'grab';
    this.secondTarget.cursor = 'grab';
    this.pressedColumn = -1;
    this.touchMoving = false;
    this.moveDistance = 0;
    this.activePointerId = null;
  }

  onTouchStart(event) {
    if (gameModuleStore.isReplay) return
    if (!gameModuleStore.canTouchControl && gameModuleStore.winAnimations.length) {
      gameModuleStore.doSpin();
    }

    if (this.returningToThePlace || event.data.buttons !== 1) return;
    if (this.activePointerId !== null && event.data.pointerId !== this.activePointerId) return;
    this.activePointerId = event.data.pointerId;
    const reelCoordinates = mousePositionToIconColumnRow(this.target, event);
    if (reelCoordinates) {
      if (!this.returningToThePlace) {
        this.stopReturn();
        this.pressedColumn = reelCoordinates.column;
        this.target.cursor = 'grabbing';
        this.moveDistance = 0;
        this.touchMoving = true;
        this.lastY = event.data.global.y;
        this.touchY = event.data.global.y;
      }
    }
  }

  returnToThePlace(forceReturn, onComplete) {
    if (this.returningToThePlace) return;

    this.returningToThePlace = true;
    this.touchMoving = false;
    this.target.cursor = 'grab';

    const finishReturn = () => {
      this.returningToThePlace = false;
      this.reset();
      if (onComplete) onComplete();
    };
    // refactor
    if ((forceReturn || gameModuleStore.canTouchControl) && this.moveDistance !== 0) {
      const data = generateTweenData(this.moveDistance, 0, 100);
      this.returnControl = startTweenData(
        null,
        data,
        (t, v) => {
          if (this.pressedColumn === -1) {
            this.stopReturn();
            finishReturn();
          } else {
            this.reels[this.pressedColumn].move(v - this.moveDistance);
            this.moveDistance = v;
          }
        },
        finishReturn
      );
    } else {
      finishReturn();
    }
  }

  onPointerMove(event) {
    if (event.data.pointerId !== this.activePointerId) return;
    if (
      event.data.buttons !== 1 ||
      this.pressedColumn === -1 ||
      !this.touchMoving ||
      this.returningToThePlace ||
      !gameModuleStore.canTouchControl
    ) {
      return;
    }

    const reelCoordinates = mousePositionToIconColumnRow(this.target, event);
    if (!reelCoordinates || reelCoordinates.column !== this.pressedColumn) {
      this.returnToThePlace();
      return;
    }

    this.moveDistance = (event.data.global.y - this.touchY) / this.target.worldTransform.d;
    const passedDistance = Math.abs(this.moveDistance);
    const spinDirection = this.moveDistance / passedDistance;

    this.reels[this.pressedColumn].move(
      (event.data.global.y - this.lastY) / this.target.worldTransform.d
    );
    this.reels[this.pressedColumn]._direction = spinDirection;
    this.lastY = event.data.global.y;

    if (passedDistance >= this.iconsHeight / 2) {
      gameModuleStore.setSpinDirection(spinDirection)
        gameModuleStore.doSpin();
        this.returnToThePlace();
    }
  }
}

export function addTouchControl(reelContainer, winContainer, reels) {
  new TouchController(reelContainer, winContainer, reels);
}
